import { SignedTileDto } from 'shared/dto/project/signed-tile.dto';
import { SurveyCardCoins } from 'src/components/SurveyCard/survey-card-coins.enum';
import { SurveyCardDataProps } from 'src/components/SurveyCard/survey-card-data-props.interface';

export function mapSignedTileToSurveyCardData(tile: SignedTileDto): SurveyCardDataProps {
  return {
    score: tile.tile.score,
    xpValue: tile.tile.xp,
    rating: tile.tile.rating,
    coinIcon: SurveyCardCoins.CoinBig,
    coinValue: tile.tile.payoutPoints,
    loiSeconds: tile.tile.loiSeconds,
    isProfileSurvey: false,
    encryptedDetails: tile.tile.tileDetailsDto,
    projectDetailsDto: tile.tile.projectDetailsDto,
    signature: tile.signature,
    isNew: tile.isNew === true,
    partnerName: tile.tile.partnerName,
  };
}
